import React from 'react';
import { Flex, Stack, Column, Row } from '@grubhubprod/gh-cookbook-react';
import { BalancePortalButton } from 'src/components/selfService/common/Balance/components/BalancePortalButton/BalancePortalButton';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { PoweredByBalance } from 'src/components/selfService/common/Balance/components/PoweredByBalance/PoweredByBalance';
import { BalancePortalPage } from 'src/components/selfService/common/Balance/balance.types';

export function BalanceCreditProgressSectionFooter(): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Row>
      <Column phone={12} tablet={6}>
        <Stack y={isPhone ? 'sm' : 'none'}>
          <BalancePortalButton
            text="Manage line of credit"
            balancePortalPage={BalancePortalPage.OUTSTANDING_INVOICES}
          />
        </Stack>
      </Column>
      <Column phone={12} tablet={6}>
        <Flex
          justifyContent={isPhone ? 'flex-start' : 'flex-end'}
          height="100%"
          alignItems="flex-end"
        >
          <PoweredByBalance />
        </Flex>
      </Column>
    </Row>
  );
}
